import {EventEmitter} from 'main.core.events';
import {EventType, Api} from 'sale.payment-pay.const';
import {FormHelper} from './form-helper';

export class Controller
{
	constructor(options)
	{
		this.options = options || {};
		this.url = this.option('url', this.getDefaultAjaxController());
		this.allowPaymentRedirect = this.option('allowPaymentRedirect', true);
		this.returnUrl = this.option('returnUrl', this.getCurrentUrl());
		this.orderId = this.option('orderId', null);
		this.paymentId = this.option('paymentId', null);
		this.accessCode = this.option('accessCode', null);
		this.response = null;
	}

	/**
	 * @public
	 * @param {object} params
	 * @returns {Error|void}
	 */
	initPayment(params)
	{
		if (!params.paySystemId)
		{
			throw new Error('Payment system undefined');
		}

		BX.ajax({
			method: 'POST',
			dataType: 'json',
			url: this.url,
			data: {
				sessid: BX.bitrix_sessid(),
				paysystemId: params.paySystemId,
				returnUrl: this.returnUrl,
				orderId: this.orderId,
				paymentId: this.paymentId,
				access: this.accessCode,
			},
			onsuccess: (response) => {
				this.response = response;
				this.handleResponse();
			},
		});
	}

	/**
	 * @private
	 */
	handleResponse()
	{
		if (this.isResponseSucceed()) {
			this.tryToRedirectUserOnPaymentGate();
			EventEmitter.emit(EventType.payment.success, this.response);
		} else {
			EventEmitter.emit(EventType.payment.error, this.response);
		}
	}

	/**
	 * @private
	 * @returns {boolean}
	 */
	isResponseSucceed()
	{
		return BX.type.isObject(this.response) && this.response.status === 'success';
	}

	/**
	 * @private
	 */
	tryToRedirectUserOnPaymentGate()
	{
		const url = BX.type.isString(this.response.url) ? this.response.url : '';
		const html = BX.type.isString(this.response.html) ? this.response.html : '';

		if (this.allowPaymentRedirect) {
			if (url.length > 0) {
				window.location.href = url;
			} else if (html.length > 0) {
				this.tryToAutoSubmitHtmlChunk(html);
			}
		}
	}

	/**
	 * @public
	 * @param {string} html
	 * @returns {void}
	 */
	tryToAutoSubmitHtmlChunk(html)
	{
		FormHelper.createFromHtml(html).submit();
	}

	/**
	 * @public
	 * @param {HTMLElement} node
	 * @returns {void}
	 */
	tryToAutoSubmitDomNode(node)
	{
		FormHelper.createFromNode(node).submit();
	}

	/**
	 * @private
	 * @returns {string}
	 */
	getDefaultAjaxController()
	{
		return Api.controller.initPayment;
	}

	/**
	 * @private
	 * @returns {string}
	 */
	getCurrentUrl()
	{
		return window.location.href;
	}

	/**
	 * @private
	 * @param {string} name
	 * @param {*} defaultValue
	 * @returns {*}
	 */
	option(name, defaultValue)
	{
		return this.options.hasOwnProperty(name) ? this.options[name] : defaultValue;
	}
}